import {useCallback, useEffect, useMemo, useRef, useState} from "react";
// import _ from "underscore";
import {NassauLog} from "../scripts/myga-utils";

// const VALID_FIRST = /^[1-9]{1}$/;
// const VALID_NEXT = /^[0-9]{1}$/;
// const DELETE_KEY_CODE = 8;

function CurrencyInput(props) {

  const {id, className, style, max, placeholder, form, value, handleChange, decimalsEnabled, required} = props;

  // const currencySymbol = Number.parseInt('0').toLocaleString('en-US', currencyOptions).substring(0,1)
  
  const [displayValue, setDisplayValue] = useState('');
  const [myValue, setMyValue] = useState(value ? value : 0);
  const firstRender = useRef(true);
  const currencyOptions = useMemo(() => {
    return decimalsEnabled ? {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    } : {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }
  }, [decimalsEnabled])
  
  useEffect(() => {
    let vs = parseInt(myValue);
    let formattedValue = '';
    if (!Number.isNaN(vs)) {
      formattedValue = vs.toLocaleString('en-US', currencyOptions);
    }
    // NassauLog(`setDisplayValue: ${formattedValue}`);
    setDisplayValue(formattedValue);
  }, [currencyOptions, myValue]);
  
  useEffect(()=>{
    if (firstRender.current) {
      firstRender.current = true;
      return;
    }
    setMyValue(value);
  },[value]);
  
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    // NassauLog(`CurrencyInput calling handleChange: "${myValue}"`);
    handleChange(myValue);
  }, [myValue,handleChange]);
  
  const currencyHandleChange = useCallback(e => {
    // remove formatting including trailing decimals.
    let nextValue = parseInt(e.target.value.replace(/[^.\d]/g, '').replace(/\.\d+/,''));
    if (isNaN(nextValue)) {
      nextValue = 0;
    }
    if (max>0) {
      nextValue = Math.min(nextValue,max);
    }
    // NassauLog(`CurrencyInput::setMyValue: ${nextValue}`);
    setMyValue(nextValue);
  },[max]);
  
  const onKeyDown = useCallback(e => {
    // Skip de-formatting for Enter, Select, Tab and Arrow keys
    // Also skip when text is selected
    if (e.keyCode === 13 || e.keyCode === 9 || e.keyCode === 37 ||
        e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40 || e.keyCode === 16)
      return
    
    // Remove entire string if deleting final non-formatting digit
    if ((e.keyCode === 8 || e.keyCode === 46) && e.target.value.length === 5) {
      e.target.value = '';
      return
    }
    
    if (window.getSelection().toString().length > 0) {
      if (e.target.selectionEnd > e.target.value.lastIndexOf('.'))
        e.target.selectionEnd = e.target.value.lastIndexOf('.')
      return
    }
    
    // Skip de-formatting for backspace
    if (e.keyCode === 8) {
      // Move the cursor to the . if cursor position is to the right of the .
      if (e.target.selectionStart > e.target.value.lastIndexOf('.')) {
        e.target.selectionStart = e.target.value.lastIndexOf('.');
        e.target.selectionEnd = e.target.selectionStart;
      }
      return
    }
    
    // Remove formatting including trailing decimals before processing keyup
    e.target.value = parseInt(e.target.value.replace(/[^.\d]/g, '').replace(/\.\d+/,''));
  }, []);
  
  // const handleKeyDown = useCallback((e)=>{
  //   const {key, keyCode} = e;
  //
  //   // make sure that we have a number
  //   let number = _.isNumber(value) ? value : Number.parseInt(value);
  //   if (Number.isNaN(number)) {
  //     number = 0;
  //   }
  //
  //   // handle key rejection
  //   if (
  //       (number === 0 && !VALID_FIRST.test(key)) ||
  //       (number !==0 && !VALID_NEXT.test(key) && keyCode !== DELETE_KEY_CODE)
  //   ) {
  //     return;
  //   }
  //
  //   let valueString = number.toString();
  //   let nextValue = 0;
  //   let selectedText = window.getSelection().toString()
  //   selectedText = selectedText.split(currencySymbol).join('')
  //   if (keyCode !== DELETE_KEY_CODE) {
  //     let nextValueString
  //     if (selectedText.length > 0) {
  //       if (decimalsEnabled) valueString = valueString.concat('.00')
  //       let selectedTextWithoutCommas = selectedText.split(',').join('')
  //       nextValueString = valueString.split(selectedTextWithoutCommas)
  //       nextValueString.splice(1,0,key)
  //       nextValueString = nextValueString.join('')
  //     } else {
  //       nextValueString = `${valueString}${key}`
  //     }
  //     nextValue = Number.parseInt(nextValueString, 10);
  //   } else {
  //     if (decimalsEnabled) valueString = valueString.concat('.00')
  //     let commaCount = selectedText.split(',').length - 1
  //     const nextValueString = valueString.slice(0,Math.min(-1, e.target.selectionStart - e.target.selectionEnd + commaCount));
  //     nextValue = nextValueString === '' ? 0 : Number.parseInt(nextValueString,10);
  //   }
  //
  //   if (nextValue > max) {
  //     return;
  //   }
  //
  //   handleChange(nextValue);
  //
  // },[max, handleChange, decimalsEnabled]);
  
  // useEffect(()=>{
  //   let vs = '';
  //   let number = _.isNumber(value) ? value : Number.parseInt(value);
  //   if (!Number.isNaN(number)) {
  //     vs = number.toLocaleString('en-US', currencyOptions);
  //     // NassauLog(`vs: ${vs}`);
  //   }
  //   setDisplayValue(vs);
  // },[value]);
  
  return (
      <input
        id={id}
        className={className}
        required={required}
        style={style}
        inputMode={'numeric'}
        onChange={currencyHandleChange}
        onKeyDown={onKeyDown}
        value={displayValue}
        placeholder={placeholder}
        form={form}
        >
      </input>
  );
}

export default CurrencyInput;